<template>
  <span v-if="!breakdown"><slot /></span>
  <template v-else>
    <button
      ref="triggerRef"
      type="button"
      class="stat-breakdown-trigger cursor-help border-b border-dotted border-gray-500"
      :aria-expanded="isOpen ? 'true' : 'false'"
      :aria-describedby="isOpen ? id : undefined"
      @mouseenter="onTriggerEnter"
      @mouseleave="onTriggerLeave"
      @focus="onTriggerEnter"
      @blur="onTriggerLeave"
      @click.stop="onTriggerClick"
      @keydown.esc="closeAll"
    >
      <slot />
    </button>

    <Teleport to="body">
      <div
        v-if="isOpen"
        :id="id"
        ref="popoverRef"
        role="tooltip"
        class="stat-breakdown-pop fixed z-[10000] w-72 p-3 bg-gray-900 border border-gray-800 rounded-lg shadow-lg text-sm text-white pointer-events-auto"
        :style="style"
        @mouseenter="onPopoverEnter"
        @mouseleave="onPopoverLeave"
      >
        <StatBreakdownContent :breakdown="breakdown" />
      </div>
    </Teleport>
  </template>
</template>

<script setup>
import useStatBreakdownPopover from '../../composables/useStatBreakdownPopover.js';
import StatBreakdownContent from './StatBreakdownContent.vue';

const props = defineProps({
  statKey: { type: String, required: true },
  source: { type: String, required: true },
  values: { type: Object, default: null },
});

const {
  id, triggerRef, popoverRef, isOpen, style, breakdown, closeAll,
  onTriggerEnter, onTriggerLeave, onPopoverEnter, onPopoverLeave, onTriggerClick,
} = useStatBreakdownPopover(props);
</script>

<style scoped>
.stat-breakdown-trigger {
  font: inherit;
  color: inherit;
  background: none;
  padding: 0;
  text-align: inherit;
}

.stat-breakdown-pop {
  animation: stat-breakdown-fade 120ms ease-out;
}

@keyframes stat-breakdown-fade {
  from { opacity: 0; }
  to { opacity: 1; }
}

@media (prefers-reduced-motion: reduce) {
  .stat-breakdown-pop {
    animation: none;
  }
}
</style>
